import { createStore } from 'vuex';
import createPersistedState from "vuex-persistedstate";
import auth from '@/store/modules/auth';
import context from '@/store/modules/context';
var store = createStore({
    // Register plugins
    plugins: [createPersistedState()],
    // Register modules
    modules: { auth: auth, context: context },
});
export default store;
